export enum AbandonedCartEventsEnum {
	CART_UPDATED = 'cart_updated',
	ORDER_COMPLETED = 'order_completed'
}
